import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import { useNavigate } from 'react-router-dom';
import { productService } from '../../service/productservice';

// Importing product images
import GroundedCrayed8oz from "../../public/category-img/seafood/blended-crayfishmain_1024x1024@2x.png";
import WholeCrayfish8oz from "../../public/category-img/seafood/wholecrayfish3_1588x.jpg";
import GroundedCrayed4oz from "../../public/category-img/seafood/blended-crayfishmain_1024x1024@2x.png";
import DryLargeShrimps10oz from "../../public/category-img/seafood/DryLargeShrimps10oz_prev_ui.png";
import SmokedCatfish12oz from "../../public/category-img/seafood/smoke-catfish-oepned_350x350.jpg";
import SmokedCatfish15Lb from "../../public/category-img/seafood/Catfishcut2_1024x1024@2x.jpg";
import DryPeriwinkle2oz from "../../public/category-img/seafood/DryPeriwinkle2oz.png";
import DriedWashedSnails6pcs from "../../public/category-img/seafood/Screenshot (351).png";
import StockfishBits12oz from "../../public/category-img/seafood/larucheimportsStockfish-Bits-Image_prev_ui.png";
import DriedSeaSnails4oz from "../../public/category-img/seafood/obiji-snail_prev_ui.png";
import TilapiaFish1LB from "../../public/category-img/seafood/TilapiaFishperpound1LB.jpeg";
import Catfish1LB from "../../public/category-img/seafood/Catfishpepound1LB_prev_ui.png";

export const seafoodsproducts = [
  { id: 'SF001', name: 'Grounded Crayed 8oz', brand: "Bukky's", price: '$13.95', supplier: "Bukky's wholesale", img: GroundedCrayed8oz, description: 'Crayfish is a highly aromatic and flavorful seafood ingredient commonly used in African cuisine to enhance the taste of soups, stews, and sauces. Rich in protein and essential minerals, it provides a savory umami boost to dishes like Egusi soup, Jollof rice, and Okra soup.' },
  { id: 'SF002', name: 'Whole Crayfish 8oz', brand: "Bukky's", price: '$14.95', supplier: "Bukky's wholesale", img: WholeCrayfish8oz, description: 'Crayfish is a highly aromatic and flavorful seafood ingredient commonly used in African cuisine to enhance the taste of soups, stews, and sauces. Rich in protein and essential minerals, it provides a savory umami boost to dishes like Egusi soup, Jollof rice, and Okra soup.' },
  { id: 'SF003', name: 'Grounded Crayed 4oz', brand: "Bukky's", price: '$7.25', supplier: "Bukky's wholesale", img: GroundedCrayed4oz, description: 'Crayfish is a highly aromatic and flavorful seafood ingredient commonly used in African cuisine to enhance the taste of soups, stews, and sauces. Rich in protein and essential minerals, it provides a savory umami boost to dishes like Egusi soup, Jollof rice, and Okra soup.' },
  { id: 'SF004', name: 'Dry Large Shrimps 10oz', brand: 'Nittemon Food', price: '$25.95', supplier: 'Nittemons food', img: DryLargeShrimps10oz, description: 'Dry Large Shrimps are sun-dried, flavor-packed seafood commonly used in African cooking to infuse dishes with a rich, savory taste. They are perfect for adding depth to soups, stews, sauces, or rice dishes like Jollof rice and fried rice.' },
  { id: 'SF005', name: 'Smoked Catfish 12oz', brand: 'LaRuche', price: '$14.95', supplier: 'Laruche distributors - Uche', img: SmokedCatfish12oz, description: 'Smoked Catfish is a flavorful and aromatic fish that has been traditionally smoked to perfection, imparting a rich, smoky taste. Popular in African cuisine, it is commonly used in soups, stews, and rice dishes, such as Egusi soup and Jollof rice.' },
  { id: 'SF006', name: 'Smoked Catfish 1.5Lb', brand: 'LaRuche', price: '$26.89', supplier: 'Laruche distributors - Uche', img: SmokedCatfish15Lb, description: 'Smoked Catfish is a flavorful and aromatic fish that has been traditionally smoked to perfection, imparting a rich, smoky taste. Popular in African cuisine, it is commonly used in soups, stews, and rice dishes, such as Egusi soup and Jollof rice.' },
  { id: 'SF013', name: 'Dry Periwinkle 2oz', brand: 'Nittemon Food', price: '$5.95', supplier: 'Nittemon foods', img: DryPeriwinkle2oz, description: 'Dry Periwinkles are sun-dried mollusks commonly used in African cuisine to add a rich, briny flavor to soups, stews, and sauces. Known for their chewy texture and unique taste, they are often used in traditional dishes like Efo Riro, Okra soup, and pepper soup.' },
  { id: 'SF014', name: 'Dried Washed Snails 6pcs', brand: 'Nittemon Food', price: '$26.95', supplier: 'Nittemon foods', img: DriedWashedSnails6pcs, description: 'Dried Washed Snails are a unique and flavorful ingredient commonly used in African cooking, offering a chewy texture and earthy taste. After being thoroughly cleaned and dried, they retain their natural flavors, making them perfect for soups, stews, and sauces.' },
  { id: 'SF015', name: 'Stockfish Bits 12oz', brand: 'LaRuche', price: '$11.94', supplier: 'Laruche distributors - Uche', img: StockfishBits12oz, description: 'Stock Fish Bits are small, dried pieces of fish, typically from cod or similar white fish, that have been preserved through salting and drying. A staple in many African cuisines, they are often used to add a deep, umami-rich flavor to soups, stews, and sauces.' },
  { id: 'SF016', name: 'Dried Sea Snails 4oz', brand: 'Obiji Foods', price: '$11.95', supplier: '', img: DriedSeaSnails4oz, description: 'Dried Sea Snails are sun-dried mollusks that bring a distinct, briny flavor and chewy texture to African dishes. Commonly used in soups, stews, and sauces, such as pepper soup or Efo Riro, they offer a rich taste that enhances the depth of traditional recipes.' },
  { id: 'SF017', name: 'Tilapia Fish, per pound, 1LB', brand: 'Unbranded', price: '$8.29', supplier: 'Laruche distributors - Uche', img: TilapiaFish1LB, description: 'Tilapia Fish is a mild-flavored, versatile fish commonly used in African cuisine for grilling, frying, or adding to soups and stews. Rich in protein and omega-3 fatty acids, it offers numerous health benefits while providing a tender, flaky texture.' },
  { id: 'SF018', name: 'Catfish, per pound, 1LB', brand: 'Unbranded', price: '$9.99', supplier: 'Laruche distributors - Uche', img: Catfish1LB, description: 'Catfish is a flavorful, firm-textured fish that is widely enjoyed in African cuisine for its versatility in a variety of dishes. Rich in protein and omega-3 fatty acids, it offers numerous health benefits while providing a mild, slightly sweet taste.' }
];

const ProductCard = ({ product, updateCartCount, forceUpdateKey }) => {
  const [inCart, setInCart] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const foundItem = storedCartItems.find((item) => item.id === product.id);
    if (foundItem) {
      setInCart(true);
      setQuantity(foundItem.quantity);
    } else {
      setInCart(false);
      setQuantity(0);
    }
  }, [product.id, forceUpdateKey]);

  const handleAddToCart = () => {
    if (!inCart) {
      setInCart(true);
      setQuantity(1);
      saveToLocalStorage(product, 1);
      updateCartCount();
    }
  };

  const handleProductClick = () => {
    navigate(`/product/${product.name}`);
  };

  const saveToLocalStorage = (product, quantity) => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const updatedCart = [...cartItems, { ...product, quantity }];
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-3 w-full flex flex-col justify-between">
      <div onClick={handleProductClick} className="relative cursor-pointer flex justify-center items-center">
        <img
          src={product.img}
          alt={product.name}
          className={`h-60 w-full object-cover rounded-lg ${product.quantity === 0 ? 'opacity-50' : ''}`}
        />
        {product.quantity === 0 && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
            <span className="text-white text-lg font-semibold">Out of Stock</span>
          </div>
        )}
      </div>
      <div className="mt-4">
        <h3 className="text-lg font-semibold">{product.name}</h3>
        <p className="text-[#007D44]">{product.brand}</p>
        <p className="text-[#007D44] font-bold mt-2">${product.price}</p>
      </div>
      {inCart ? (
        <div className="mt-4 flex items-center justify-between border bg-slate-100 shadow-md rounded-full">
          <button
            onClick={() => {
              if (quantity > 1) {
                setQuantity((prevQuantity) => prevQuantity - 1);
                updateCartCount();
              }
            }}
            className="bg-[#38c13a] text-white py-2 px-4 rounded-lg hover:bg-[#2e9830]"
          >
            -
          </button>
          <span className="text-lg font-semibold">{quantity}</span>
          <button
            onClick={() => {
              setQuantity((prevQuantity) => prevQuantity + 1);
              updateCartCount();
            }}
            className="bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44]"
          >
            +
          </button>
        </div>
      ) : (
        <button
          onClick={handleAddToCart}
          className={`mt-4 bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44] ${
            product.quantity === 0 ? 'cursor-not-allowed opacity-50' : ''
          }`}
          disabled={product.quantity === 0}
        >
          Add to cart
        </button>
      )}
    </div>
  );
};



const Seafood = () => {
  const [cartCount, setCartCount] = useState(0);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);


  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [cloudinaryUrls, setCloudinaryUrls] = useState({});
  const [products, setProducts] = useState([]);
  const [hasIncompatibleItems, setHasIncompatibleItems] = useState(false); // New state
      

 // Auto-upload products when component mounts
 useEffect(() => {
  const uploadProducts = async () => {
    try {
      setIsUploading(true);

      // Prepare products for upload
      const productsToUpload = seafoodsproducts.map(product => ({
        ...product,
        id: product.id,
        name: product.name,
        brand: product.brand,
        description: product.description,
        category: 'seafoodsproducts',
        quantity: 0,
        price: parseFloat(product.price.replace('$', ''))
      }));

      try {
        const result = await productService.bulkCreateProducts(productsToUpload);
        
        setUploadStatus({
          success: true,
          message: `${result.created} beauty products uploaded successfully`
        });
      } catch (error) {
        setUploadStatus({
          success: false,
          message: error.response?.data?.message || 'Product upload failed'
        });
      }
    } catch (error) {
      console.error('Error uploading products:', error);
      setUploadStatus({
        success: false,
        message: 'Failed to upload products'
      });
    } finally {
      setIsUploading(false);
    }
  };


  // Fetch products by category
  const fetchProducts = async () => {
    try {
      const result = await productService.getProductsByCategory('seafoodsproducts');
      
      // If no products exist, trigger upload
      if (result.count === 0) {
        await uploadProducts();
      } else {
        setProducts(result.products);
        console.log(result.products)
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  fetchProducts();
}, []);

 

 
   useEffect(() => {
     const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
     setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
     
     // Check for incompatible items on initial load
     const hasIncompatible = storedCartItems.some(item => 
       ["Large Box", "Small Box", "Discount"].includes(item.orderType)
     );
     setHasIncompatibleItems(hasIncompatible);
 
   }, []);
 
   const updateCartCount = () => {
     const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
     setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
     
     // Check for incompatible items whenever cart updates
     const hasIncompatible = storedCartItems.some(item => 
       ["Large Box", "Small Box", "Discount"].includes(item.orderType)
     );
     setHasIncompatibleItems(hasIncompatible);
   };

  const forceUpdateProducts = () => {
    setForceUpdateKey(prevKey => prevKey + 1); // This will force a re-render in ProductCard
  };

  return (
    <>
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} forceUpdateProducts={forceUpdateProducts} /> {/* Pass cart count to Navbar */}

      {/* Upload Status Notification */}
      {isUploading && (
        <div className="fixed top-0 left-0 w-full bg-yellow-500 text-white text-center py-2 z-50">
          Uploading sponge products...
        </div>
      )}
      
      {uploadStatus && (
        <div 
          className={`
            fixed 
            top-0 
            left-0 
            w-full 
            text-center 
            py-2 
            z-50 
            ${uploadStatus.success ? 'bg-green-500' : 'bg-red-500'} 
            text-white
          `}
        >
          {uploadStatus.message}
        </div>
      )}

      <div className="min-h-screen p-8 max-sm:p-1 lg:mt-[70px] mt-[130px]">
      {hasIncompatibleItems && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">
            Your cart contains items from a different box type. Please complete your current order 
            or clear the cart before selecting individual sponge products.
          </span>
          <button
            onClick={() => setHasIncompatibleItems(false)}
            className="absolute top-0 right-0 px-2 py-1"
          >
            ×
          </button>
        </div>
      )}
        <div className="flex justify-between items-center max-sm:flex-col max-sm:items-start mb-6">
          <h3 className="text-2xl font-semibold">Seafoods Products</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              updateCartCount={updateCartCount}
              forceUpdateKey={forceUpdateKey} // Pass updateCartCount to ProductCard
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Seafood;